import React, { useEffect, useState } from "react";
import { Image, Header } from "semantic-ui-react";

import Moment from "react-moment";
import * as auth from "../../modules/Auth/_redux/authRedux";

import { useLocation } from "react-router";
import { checkIsActive } from "../../../_metronic/_helpers";

import Add from "./add";
import Edit from "./edit";

import Filters from "./filters";
import Preview from "./preview";
import { useDispatch, useSelector, connect } from "react-redux";
import { usePermissionsSimplified } from "../../../hooks/usePermissionsSimplified";
import UserProfilePlaceholder from "../../components/common/userProfilePlaceholder";
import { selectTranslations } from "../../config/i18n/slice";
import useGetCurrentTimeAccZone from "../../../hooks/useGetCurrentTimeAccZone";

import {
  ArrowLeft,
  ArrowRight,
  CloseIcon,
  CustomerIcon,
  PlusIcon,
  SortIcon,
  VendorBlueIcon,
} from "../../../Assets/Icons/svg";

import DataTable from "react-data-table-component";
import useDisplayFormattedText from "../../../hooks/useDisplayFormattedText";
import ToolTip from "react-power-tooltip";
import Pagination from "../../components/common/CommonPagination";
import {
  fetchAllVendorData,
  fetchVendorInitData,
  fetchVendorWithFilter,
} from "../../../redux/reducers/vendorReducer";
import { useDebounce } from "use-debounce";
import Animation from "../../components/common/CustomLoader";
import { humanize } from "../../config/common/commonFunctions";
import { getUserData } from "../../config/sharedApi/peopleApis";
import EmptyFilter from "../Customers/emptyFilter";

const Vendors = (props) => {
  const { userPermissions } = usePermissionsSimplified();
  const t = useSelector(selectTranslations);
  const dispatch = useDispatch();
  const [allIds, setAllIds] = useState([]);
  const organisationId = useSelector((state) => {
    if (state?.auth?.user?.organisation) {
      return state.auth.user.organisation.id;
    } else {
      return null;
    }
  });

  const user = useSelector((state) => {
    if (state?.auth?.user) {
      return state.auth.user;
    } else {
      return null;
    }
  });

  const selectedLanguage = useSelector((state) => {
    if (state?.i18n?.lang) {
      return state.i18n.lang;
    } else {
      return "en";
    }
  });

  const currentUserLocations = useSelector((state) => {
    if (state?.auth?.user?.id) {
      return state.auth.user.locations;
    } else {
      return null;
    }
  });

  const role = useSelector((state) => {
    if (state?.auth?.user?.id) {
      return state.auth.user.role.type;
    } else {
      return null;
    }
  });

  const allIdsArray = [];

  currentUserLocations?.length &&
    currentUserLocations.forEach((location) => {
      if (!allIdsArray.some((inv) => inv == location?.id)) {
        allIdsArray.push(location?.id);
      }

      location.subLocations.forEach((subLocation) => {
        if (!allIdsArray.some((inv) => inv == subLocation?.id)) {
          allIdsArray.push(subLocation?.id);
        }
      });
    });

  const {
    data,
    allVendorData,
    isLoading: loading,
    error,
    initData,
    page,
    pageSize,
    total,
    initLoading,
  } = useSelector((state) => ({
    data: state.vendor.vendorData,
    allVendorData: state.vendor.allVendorData,
    isLoading: state.vendor.isLoading,
    error: state.vendor.error,
    initData: state.vendor.vendorInitData,
    page: state.vendor.page,
    pageSize: state.vendor.pageSize,
    total: state.vendor.total,
    initLoading: state.vendor.initLoading,
  }));
  const [loadUserData, setLoadUserData] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [showTooltip, setShowTooltip] = useState(false);
  const [modalWidth, setModalWidth] = useState(
    Math.max(window.innerWidth / 2, 514)
  );
  const [loader, setloader] = useState(false);
  const [searchTitle, setSearchTitle] = useState("");
  const [debounceValue] = useDebounce(searchTitle, 500);
  const [sortData, setSortData] = useState([]);
  const [selectedStartDates, setSelectedStartDates] = useState([]);
  const [selectedEndDates, setSelectedEndDates] = useState([]);

  const [toggleAsideModal, setToggleAsideModal] = useState(false);
  const [toggleEditModal, setToggleEditModal] = useState(false);
  const [togglePreviewModal, setTogglePreviewModal] = useState(false);
  const [targetedData, setTargetedData] = useState({});
  const [fetching, setFetchLoading] = useState(true);
  const [refresh, setRefresh] = useState(true);

  const [filterOptions, setFilterOptions] = useState({
    locations: [],
    cities: [],
  });
  const curentUrl = useLocation();
  const queryParams = new URLSearchParams(curentUrl.search);
  const partId = queryParams.get("id");

  useEffect(() => {
    setAllIds(allIdsArray);
    const fetchData = async () => {
      setLoadUserData(true);
      if (!(role === "super_admin")) {
        const userData = await getUserData(user.id);

        dispatch(props.fulfillUser(userData));
      }
      const fetchVendorData = await dispatch(
        fetchVendorInitData({ organisationId, role, allIds: allIdsArray })
      );
      setLoadUserData(false);
      if (fetchVendorData) {
        if (partId) {
          const fetchAllData = await dispatch(
            fetchAllVendorData({ organisationId, role, allIds: allIdsArray })
          );

          let selectedPart = fetchAllData.payload.response.find(
            (each) => each.attributes?.countId == partId
          );
          if (selectedPart) {
            setTargetedData(selectedPart);
            setTogglePreviewModal(true);
          }
        }

        setFetchLoading(false);
      }
    };

    fetchData();
  }, [refresh, partId]);

  const { DisplayFormattedText } = useDisplayFormattedText();

  const location = useLocation();
  const getMenuItemActive = (url, hasSubmenu = false) => {
    return checkIsActive(location, url);
  };

  const customStyles = {
    headCells: {
      style: {
        paddingTop: "11px",
      },
    },
    cells: {
      style: {
        paddingLeft: "16px",
        paddingRight: "16px",
        paddingTop: "19px",
        paddingBottom: "19px",
      },
    },
  };

  const columns = [
    {
      width: selectedLanguage === "en" ? "133px" : "150px",
      name: t.assets.table.ID,
      sortField: "countNumId",
      sortable: true,
      cell: (row) => (
        <span
          onClick={() => {
            setTargetedData(row);
            setTogglePreviewModal(true);
          }}
          className="id-text-style"
        >
          {row?.attributes?.countId}
        </span>
      ),
    },
    {
      name: t.vendors.table.name,
      sortField: "name",
      sortable: true,
      minWidth: "180px",
      cell: (row) => {
        if (row?.attributes?.logo?.data) {
          return (
            <div
              onClick={() => {
                setTargetedData(row);
                setTogglePreviewModal(true);
              }}
              className="d-flex align-items-center"
            >
              <div className="text-center">
                <Image
                  avatar
                  title={row?.attributes?.name}
                  src={`${row?.attributes?.logo?.data.attributes.url}`}
                  className={`profile-img ${
                    selectedLanguage === "en" ? "overlapping" : "number-avatar"
                  }`}
                  // style={
                  //   selectedLanguage === "en"
                  //     ? { width: "34px", height: "34px", right: "6px" }
                  //     : { width: "34px", height: "34px", right: "-6px" }
                  // }
                />
              </div>
              <div className="username-container ml-1">
                <p className="user-text">
                  {DisplayFormattedText(humanize(row?.attributes?.name), 8)}
                </p>
              </div>
            </div>
          );
        } else {
          return (
            <div
              onClick={() => {
                setTargetedData(row);
                setTogglePreviewModal(true);
              }}
              className="d-flex align-items-center"
            >
              <div className="text-center">
                <UserProfilePlaceholder
                  name={row?.attributes?.name}
                  width={"34px"}
                  height={"34px"}
                  right={selectedLanguage === "en" ? "6px" : "-6px"}
                />
              </div>
              <div className="username-container ml-1">
                <p className="user-text">
                  {DisplayFormattedText(humanize(row?.attributes?.name), 8)}
                </p>
              </div>
            </div>
          );
        }
      },
    },

    {
      sortField: "phone",
      minWidth: "160px",
      name: t.customers.table.phone,

      sortable: true,
      cell: (row) =>
        row.attributes?.phone
          ? `${selectedLanguage == "en" ? "+" : ""}${row.attributes?.phone}${
              selectedLanguage == "ar" ? "+" : ""
            }`
          : t.common.na,
    },

    {
      minWidth: "150px",
      sortField: "email",
      name: t.customers.table.email,

      sortable: true,
      cell: (row) =>
        row?.attributes?.email ? (
          <span
            onClick={() => {
              setTargetedData(row);
              setTogglePreviewModal(true);
            }}
          >
            {DisplayFormattedText(row?.attributes?.email, 10)}
          </span>
        ) : (
          t.common.na
        ),
    },

    {
      name: t.workOrders.table.location,
      sortField: "location.name",
      minWidth: "150px",

      sortable: true,
      cell: (row) => (
        <span
          onClick={() => {
            setTargetedData(row);
            setTogglePreviewModal(true);
          }}
          className=""
        >
          {DisplayFormattedText(
            row?.attributes?.location?.data?.attributes.name,
            12
          ) || t.common.na}
        </span>
      ),
    },

    {
      sortField: "serviceType",
      name: t.customers.table.service_type,

      sortable: true,
      minWidth: "165px",
      cell: (row) =>
        row?.attributes?.serviceType
          ? DisplayFormattedText(row?.attributes?.serviceType, 16)
          : t.common.na,
    },

    {
      name: t.vendors.form.start_dt,
      minWidth: "170px",
      sortField: "startDate",

      sortable: true,

      cell: (row) => {
        if (row?.attributes?.startDate) {
          return (
            <div
              onClick={() => {
                setTargetedData(row);
                setTogglePreviewModal(true);
              }}
            >
              <div>
                <Moment format="DD.MM.YYYY" date={row?.attributes?.startDate} />
              </div>
              <div className="time-text-style text-left">
                <Moment format="h a" date={row?.attributes?.startDate} />
              </div>
            </div>
          );
        } else {
          return t.common.na;
        }
      },
    },
    {
      name: t.vendors.form.end_dt,
      minWidth: "170px",
      sortField: "endDate",

      sortable: true,

      cell: (row) => {
        if (row?.attributes?.endDate) {
          return (
            <div
              onClick={() => {
                setTargetedData(row);
                setTogglePreviewModal(true);
              }}
            >
              <div>
                <Moment format="DD.MM.YYYY" date={row?.attributes?.endDate} />
              </div>
              <div className="time-text-style text-left">
                <Moment format="h a" date={row?.attributes?.endDate} />
              </div>
            </div>
          );
        } else {
          return t.common.na;
        }
      },
    },
  ];

  const handleSetDataByFilter = (newData) => {};

  const handleSort = async (column, sortDirection) => {
    setloader(true);

    const sort = [`${column.sortField}:${sortDirection}`];
    setSortData(sort);
    const sortedData = await dispatch(
      fetchVendorWithFilter({
        organisationId,
        searchName: debounceValue,
        page: page,
        pageSize: pageSize,
        location: filterOptions.locations,
        startDate: selectedStartDates,
        endDate: selectedEndDates,
        sort,
        role,
        allIds,
      })
    );

    setloader(false);
  };

  const handleRemoveSorting = async () => {
    setloader(true);

    const sort = undefined;
    setSortData(sort);
    const sortedData = await dispatch(
      fetchVendorWithFilter({
        organisationId,
        searchName: debounceValue,
        page: page,
        pageSize: pageSize,
        location: filterOptions.locations,
        startDate: selectedStartDates,
        endDate: selectedEndDates,
        sort,
        role,
        allIds,
      })
    );

    setloader(false);
  };

  const getPaginatedData = (dataToPaginate) => {
    const startIndex = (currentPage - 1) * pageSize;
    const endIndex = startIndex + pageSize;
    return dataToPaginate.slice(startIndex, endIndex);
  };

  const totalFilteredPages = Math.ceil(data.length / pageSize);

  return (
    <>
      <div className="new-listing-container table-header-dashboard stick-header pb-5">
        <div className="header-actions">
          <Header className="procedure-title mt-5" as="h2">
            {" "}
            <CustomerIcon />
            {t.aside.customersVendors}
          </Header>
          <div></div>

          {userPermissions?.vendor?.create && initData.length > 0 ? (
            <button
              onClick={() => {
                setToggleAsideModal(true);
              }}
              type="button"
              className="add-button vendor"
            >
              <span className="add-button-text">
                {" "}
                {t.vendors.title_vendor_1}
              </span>
              <span className="add-button-img">
                <PlusIcon />
              </span>
            </button>
          ) : null}
        </div>
        {!(initLoading || loadUserData) && initData?.length > 0 ? (
          <div className="new-listing-filter wo-filter sticky-filter mt-8">
            <Filters
              data={initData}
              role={role}
              allIds={allIds}
              fileData={data}
              setDataByFilter={handleSetDataByFilter}
              hasStatus={false}
              setFilterOptions={setFilterOptions}
              filterOptions={filterOptions}
              debounceValue={debounceValue}
              setSearchTitle={setSearchTitle}
              searchTitle={searchTitle}
              setloader={setloader}
              loader={loader}
              setSelectedEndDates={setSelectedEndDates}
              setSelectedStartDates={setSelectedStartDates}
              selectedEndDates={selectedEndDates}
              selectedStartDates={selectedStartDates}
              setSortData={setSortData}
              sortData={sortData}
            />
          </div>
        ) : null}
      </div>
      <div className="new-listing-container">
        {initLoading || loadUserData ? (
          <div className="d-flex animation-div justify-content-center align-items-center">
            <Animation />
          </div>
        ) : (
          <div className="new-listing-filter">
            {initData.length > 0 ? (
              <>
                {error ? (
                  <div className="mt-8 mb-8 ">
                    <Animation />
                  </div>
                ) : (
                  <DataTable
                    className="datatable-div"
                    columns={columns}
                    onSort={handleSort}
                    fixedHeader
                    data={data}
                    customStyles={customStyles}
                    noDataComponent={
                      initData.length > 0 ? (
                        <div className="no-data-container">
                          <div className="">
                            <p className="no-data-text">
                              {t.common.no_result_found}
                            </p>
                          </div>
                        </div>
                      ) : null
                    }
                    direction={selectedLanguage === "en" ? "ltr" : "rtl"}
                    onRowClicked={(row) => {
                      setTargetedData(row);
                      setTogglePreviewModal(true);
                    }}
                    sortIcon={
                      sortData ? (
                        <div>
                          <span>
                            <SortIcon />
                          </span>
                          <span
                            onClick={(e) => {
                              e.stopPropagation();
                              handleRemoveSorting();
                            }}
                          >
                            <CloseIcon />
                          </span>
                        </div>
                      ) : (
                        <span></span>
                      )
                    }
                    persistTableHead={true}
                    pointerOnHover={true}
                    highlightOnHover={true}
                    progressPending={loader}
                    progressComponent={
                      <div className="mt-8 mb-8 ">{t.common.loading}</div>
                    }
                  />
                )}

                <div className="d-flex justify-content-end">
                  <Pagination
                    ofString={t.common.of}
                    total={total}
                    prevItem={
                      selectedLanguage === "en" ? <ArrowLeft /> : <ArrowRight />
                    }
                    nextItem={
                      selectedLanguage === "en" ? <ArrowRight /> : <ArrowLeft />
                    }
                    page={page}
                    limit={pageSize}
                    handleNext={async () => {
                      setloader(true);
                      await dispatch(
                        fetchVendorWithFilter({
                          organisationId,
                          searchName: debounceValue,
                          page: page + 1,
                          pageSize: pageSize,
                          location: filterOptions.locations,
                          startDate: selectedStartDates,
                          endDate: selectedEndDates,
                          sort: sortData,
                          role,
                          allIds,
                        })
                      );
                      setloader(false);
                    }}
                    handlePrevious={async () => {
                      setloader(true);
                      await dispatch(
                        fetchVendorWithFilter({
                          organisationId,
                          searchName: debounceValue,
                          page: page - 1,
                          pageSize: pageSize,
                          location: filterOptions.locations,
                          startDate: selectedStartDates,
                          endDate: selectedEndDates,
                          sort: sortData,
                          role,
                          allIds,
                        })
                      );
                      setloader(false);
                    }}
                  />
                </div>
              </>
            ) : (
              <div>
                <EmptyFilter vendor={true} customer={false} />

                <div className="no-data-container">
                  <div className="no-work-orders pb-15">
                    <VendorBlueIcon />
                    <p className="no-data-text">
                      {t.common.there_no_customer}{" "}
                      <span
                        className="position-relative c-pointer link-text"
                        onMouseOver={() => setShowTooltip(true)}
                        onMouseLeave={() => setShowTooltip(false)}
                      >
                        <ToolTip
                          color="#fff"
                          backgroundColor="#172B4D"
                          position="top left"
                          show={showTooltip}
                          textBoxWidth={
                            selectedLanguage == "ar" ? "75px" : "55px"
                          }
                          arrowAlign="start"
                          fontSize="14px"
                          fontWeight="400"
                          fontFamily={
                            selectedLanguage == "ar"
                              ? "Noto Kufi Arabic"
                              : "Roboto"
                          }
                          padding="0px 0px 0px 8px"
                          borderRadius="5px"
                          static
                          moveRight="80px"
                          moveUp="-1px"
                        >
                          <span className="work-order-tooltip">
                            {t.vendors.how_to_add_vendor}
                          </span>
                        </ToolTip>
                        {" " + t.vendors.vendors + " "}
                      </span>{" "}
                      {t.common.added_customer}
                    </p>
                    {userPermissions?.vendor?.create ? (
                      <button
                        className="work-order-button-transparent"
                        onClick={() => {
                          setToggleAsideModal(true);
                        }}
                      >
                        {t.vendors.no_vendor_added}
                      </button>
                    ) : null}
                  </div>
                </div>
              </div>
            )}
          </div>
        )}

        <Preview
          setModalWidth={setModalWidth}
          modalWidth={modalWidth}
          toggled={togglePreviewModal}
          untoggle={() => {
            setTogglePreviewModal(false);
            setModalWidth(Math.max(window.innerWidth / 2, 514));
            setTargetedData();
          }}
          edit={() => {
            setTogglePreviewModal(false);
            setToggleEditModal(true);
          }}
          targetedData={targetedData}
          refresh={refresh}
          setRefresh={setRefresh}
        />

        <Edit
          targetedData={targetedData}
          role={role}
          setAllIds={setAllIds}
          setToggleEditModal={setToggleEditModal}
          allIds={allIds}
          toggled={toggleEditModal}
          untoggle={() => {
            setModalWidth(Math.max(window.innerWidth / 2, 514));
            setToggleEditModal(false);
            setTargetedData();
          }}
          refresh={refresh}
          setRefresh={setRefresh}
          setFilterOptions={setFilterOptions}
          setSearchTitle={setSearchTitle}
        />

        <Add
          toggled={toggleAsideModal}
          setToggleAddModal={setToggleAsideModal}
          setAllIds={setAllIds}
          role={role}
          allIds={allIds}
          untoggle={() => {
            setToggleAsideModal(false);
            setModalWidth(Math.max(window.innerWidth / 2, 514));
          }}
          refresh={refresh}
          setRefresh={setRefresh}
          setFilterOptions={setFilterOptions}
          setSearchTitle={setSearchTitle}
        />
      </div>
    </>
  );
};
export default connect(null, auth.actions)(Vendors);
